<template>
  <pre-auth-view>
    <form @submit.prevent="login">
      <bdg-text-field name="Email" v-model="email" required />
      <bdg-password-field name="Password" v-model="password" required />
      <bdg-button
        class="w-full mt-8 uppercase"
        type="submit"
        :is-loading="isLoggingIn"
      >
        Log In
      </bdg-button>
    </form>
    <router-link class="forgot-password-link" :to="{ name: 'forgot-password' }">
      Forgot password?
    </router-link>
  </pre-auth-view>
</template>

<script>
import BdgTextField from "../../forms/fields/BdgTextField";
import { ApiResponseStatus } from "../../constants/enums";
import BdgButton from "../../elements/BdgButton";
import BdgPasswordField from "../../forms/fields/BdgPasswordField";
import PreAuthView from "./PreAuthView";

export default {
  name: "Login",
  components: { PreAuthView, BdgPasswordField, BdgButton, BdgTextField },
  data() {
    return {
      email: null,
      password: null
    };
  },
  computed: {
    isLoggingIn() {
      return this.$store.state.isLoggingIn;
    }
  },
  methods: {
    login() {
      if (this.email === "admin" && this.password === "password") {
        window.localStorage.overrideAuth = true;
        this.$router.push("/");
      }
      const data = {
        email: this.email,
        password: this.password
      };

      this.$store.dispatch("login", data).then(res => {
        if (res === ApiResponseStatus.SUCCESS) {
          this.$router.push({ name: "dashboard" });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.forgot-password-link {
  @apply inline-block w-full mt-8 text-blue text-center underline;
}
</style>
